import { Button } from '@/Atomic/Molecules/Button'

interface TimerecordActionsProps {
  onInfo: () => void
  onCopy?: () => void
  onEdit?: () => void
  onDelete?: () => void
  onAdd: () => void
}

export const TimerecordActions = ({
  onInfo,
  onCopy,
  onEdit,
  onDelete,
  onAdd,
}: TimerecordActionsProps) => {
  return (
    <div className="time-record-actions">
      <Button
        variant="icon"
        icon="info-circle"
        size="sm"
        onClick={(e) => {
          e.stopPropagation()
          onInfo()
        }}
      />
      {onCopy && (
        <Button
          variant="icon"
          icon="copy"
          size="sm"
          onClick={(e) => {
            e.stopPropagation()
            onCopy()
          }}
        />
      )}
      {onEdit && (
        <Button
          variant="icon"
          icon="edit"
          size="sm"
          onClick={(e) => {
            e.stopPropagation()
            onEdit()
          }}
        />
      )}
      {onDelete && (
        <Button
          variant="icon"
          icon="bin"
          size="sm"
          iconClassName="btn-delete"
          onClick={(e) => {
            e.stopPropagation()
            onDelete()
          }}
        />
      )}
      <Button
        variant="icon"
        icon="add-circle"
        size="sm"
        onClick={(e) => {
          e.stopPropagation()
          onAdd()
        }}
      />
    </div>
  )
}
